// Use class 'trix-slider-selector' to select text in the v-trix-horizontal-slider slider
import $ from 'jquery';

export default {
    install: (app, options) => {
        app.directive('trix-horizontal-slider', (el, binding, vnode) => {
            let addingClass = 'sliding';
            if (binding.value) {
                addingClass = binding.value
            }

            el.addEventListener('mousedown', (e) => {
                if (e.which !== 1) return
                else if (el.scrollWidth <= el.clientWidth) return

                for (const key in e.path) {
                    const thisPath = e.path[key];

                    if (thisPath == el) {
                        break
                    } else if (thisPath.classList.contains('trix-slider-selector')) {
                        return
                    }
                }
                let mouseStartX = e.screenX
                let lastMousePosX = mouseStartX
                let firstMouseMoveEmited = false
                // console.log('onmousedown');

                document.addEventListener('mousemove', onSlideMouseMove)
                el.addEventListener('mouseleave', onSlideEnd)
                document.addEventListener('mouseup', onSlideEnd)

                function onSlideEnd() {
                    // console.log('onmouseup');
                    el.classList.remove(addingClass)
                    $(el).css({
                        'scroll-snap-type': '',
                        'scroll-behavior': ''
                    })
                    document.removeEventListener('mousemove', onSlideMouseMove)
                    el.removeEventListener('mouseleave', onSlideEnd)
                    document.removeEventListener('mouseup', onSlideEnd)
                }

                function onSlideMouseMove(e) {
                    let thisScrollLeft = el.scrollLeft
                    // if (thisScrollLeft <= 0 && lastMousePosX <= e.screenX) {
                    //     lastMousePosX = e.screenX
                    //     return
                    // }

                    if (!firstMouseMoveEmited) {
                        firstMouseMoveEmited = true
                        el.classList.add(addingClass)
                        $(el).css({
                            'scroll-snap-type': 'none',
                            'scroll-behavior': 'unset'
                        })
                    }

                    let delta = lastMousePosX - e.screenX
                    el.scrollLeft += delta
                    lastMousePosX = e.screenX
                }
            })
        })
    }
}